import * as APIRoutes from '@mm/api-routes';
import AuthenticatedController from './AuthenticatedController';

export default class AffiliatesController extends AuthenticatedController {
  static fetchForCurrentUser() {
    return super.get(APIRoutes.AFFILIATE_FOR_USER);
  }

  static deleteAffiliate(id: number) {
    return super.delete(APIRoutes.AFFILIATE_URL(id));
  }

  static putAffiliate(id: number, paypalEmail: string) {
    return super.put(APIRoutes.AFFILIATE_URL(id), { paypalEmail });
  }

  static post(paypalEmail?: string) {
    const body = paypalEmail ? { paypalEmail } : {};
    return super.post(APIRoutes.AFFILIATES_URL, body);
  }
}
